import React from 'react';

// Reusable progress bar for "filled / max spots".
export default function SpotsBar({ filled, max, className = '' }) {
  const pct = max > 0 ? Math.min(100, Math.round((filled / max) * 100)) : 0;
  const full = filled >= max;
  return (
    <div className={`space-y-1 ${className}`} data-testid="spots-bar">
      <div className="h-2 bg-[#e3dcd1] rounded-full overflow-hidden">
        <div
          data-testid="spots-bar-fill"
          className={`h-full rounded-full transition-all ${
            full ? 'bg-amber-500' : 'bg-[#015e3f]'
          }`}
          style={{ width: `${pct}%` }}
        />
      </div>
      <div className="flex justify-between text-[11px] text-[#6a766e]">
        <span>
          <span className="font-medium text-[#013523]" data-testid="spots-bar-filled">{filled}</span>
          {' '}/ <span data-testid="spots-bar-max">{max}</span> spots
        </span>
        <span data-testid="spots-bar-remaining">
          {full ? 'Full' : `${max - filled} remaining`}
        </span>
      </div>
    </div>
  );
}
